import { defineComponent as _defineComponent } from 'vue'
import useUser from '@/mixins/useUser';
import { useArrayFilter, useAsyncState } from '@vueuse/core';
import { searchOffers } from '@/services/OffersService';
import { ProjectOfferSearchRequest } from '@/models/MyProjects';
import { computed } from 'vue';
import ProjectOffersList from '@/views/project-forum/components/sidebar-actions/ProjectOffersList.vue';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';
import { getRouteForProjectId } from '@/views/my-projects/utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOffersListBox',
  props: {
  projectId: {
    type: String,
    default: ''
  },
  onPage: Boolean
},
  setup(__props) {

const props = __props;



const { tUserFallback: t } = useUser('self');

const to = computed(() => getRouteForProjectId(props.projectId));

const { userId, companyId, isCustomer } = useUser('self');

const { state: offers } = useAsyncState(async () => {
  const request: ProjectOfferSearchRequest = {
    [isCustomer.value ? 'companyId' : 'userId']: isCustomer.value ? companyId.value : userId.value,
    projectId: props.projectId
  };
  return searchOffers(request);
}, []);

const offersSorted = computed(() => [...offers.value].sort((offerA, offerB) => (new Date(offerB.created).getTime()) - (new Date(offerA.created).getTime())));

const openOffers = useArrayFilter(offersSorted, (offer) => ['OPEN', 'OPEN_CHANGED'].includes(offer.status));
const otherOffers = useArrayFilter(offersSorted, (offer) => !['OPEN', 'OPEN_CHANGED', 'DECLINED', 'AUTO_REJECTED', 'WITHDRAWN', 'WITHDRAWN_QUEUED', 'ACCEPTED', 'EXPIRED', 'QUEUED'].includes(offer.status));
const acceptedOffers = useArrayFilter(offersSorted, (offer) => offer.status === 'ACCEPTED');
const expiredOffers = useArrayFilter(offersSorted, (offer) => offer.status === 'EXPIRED');
const activeOffers = computed(() => openOffers.value.length + otherOffers.value.length + acceptedOffers.value.length);

// const emit = defineEmits(['offers']);
// watch(openOffers, (newOpenOffers) => {
//  emit('offers', newOpenOffers.length);
// });


return { __sfc: true,props, t, to, userId, companyId, isCustomer, offers, offersSorted, openOffers, otherOffers, acceptedOffers, expiredOffers, activeOffers, ProjectOffersList, MarvinInfoBox }
}

})